export enum VehicleType {
  TURISMO = 1,
  MONOVOLUMEN = 2,
  TODOTERRENO = 3,
  SUV = 4,
  COUPE = 5
}

export const VehicleTypeSimple: { [key: number]: string } = {
  1: 'tourism',
  2: 'minivan',
  3: 'atv',
  4: 'suv',
  5: 'coupe'
};

